

































































































































import { Component, Vue } from 'vue-property-decorator'
import { message } from 'ant-design-vue'
import ViewBase from '@/util/ViewBase'
import { changePwd } from '@/api/admin'

message.config({ top: '200px' })

@Component
export default class MainLayout extends ViewBase {
  navList: any = []

  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  visible: boolean = false

  confirmLoading: boolean = false
  lang: any = {}
  form = {}
  adminname = ''
  item: any = {
    password: ''
  }
  confirmDirty: boolean = false
  // 是否为嵌入模式，目前只有 class header 使用
  get embed() {
    const embed = !!this.$route.meta.embed
    return embed
  }

  get nav() {
    if (
      this.$route.name === 'courseDetail' &&
      String(this.$route.params.type) === '1'
    ) {
      return 'courseMy'
    }
    if (this.$route.name === 'resourceDetail') {
      return 'courseEdit'
    }
    const nav = this.$route.meta.nav || this.$route.name
    return nav
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get school() {
    return JSON.parse(localStorage.school)
  }

  get helpUrl() {
    return this.$store.state.help
  }

  created() {
    this.lang = this.i18n.vAccountForm
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
    const user = this.$store.state.user

    if (user && user.role == 0) {
      this.adminname = 'account'
    } else {
      this.adminname = 'binding'
    }

    this.navList = [
      { name: 'courseIndex', title: this.i18n.courseIndex, icon: 'cloud' },
      { name: 'courseMy', title: this.i18n.courseMy, icon: 'read' },
      { name: 'courseEdit', title: this.i18n.courseEdit, icon: 'appstore' }
      // { name: 'classIndex', title: this.i18n.classIndex,icon: "login" /> }
    ]
  }

  showModal() {
    this.visible = true
  }

  handleOk(e: any) {
    this.handleSubmit(e)
  }

  handleCancel(e: any) {
    this.visible = false
    this.clearEnterVal()
  }

  handleConfirmBlur(e: any) {
    const value = e.target.value
    this.confirmDirty = this.confirmDirty || !!value
  }

  handleSubmit(e: any) {
    e.preventDefault()
    const form: any = this.form

    form.validateFields((err: any, vals: any) => {
      if (!err) {
        this.confirmLoading = true
        const pdata = {
          password: vals.password,
          oldPassword: vals.oldPassword,
          repwd: vals.repwd
        }
        this.onOk(pdata)
      }
    })
  }
  clearEnterVal() {
    const form: any = this.form
    form.resetFields()
  }
  onRepwdValidator(rule: any[], value: string, callback: any) {
    // const form: any = this.form
    // const pwd = form.getFieldValue('password')
    // pwd == (value || '').trim()
    //   ? callback()
    //   : callback(new Error(this.lang.checkPassword))
    const form: any = this.form
    if (value && value !== form.getFieldValue('password')) {
      callback(this.lang.checkPassword)
    } else {
      callback()
    }
  }

  onPwdValidator(rule: any[], value: string, callback: any) {
    const form: any = this.form
    if (value && this.confirmDirty) {
      form.validateFields(['repwd'], { force: true })
    }
    callback()
  }

  async onOk(pdata: any) {
    try {
      const res = await changePwd(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      const form: any = this.form
      form.resetFields()
      this.visible = false
      this.clearEnterVal()
      this.$message.success(this.i18n.vCourse.changeSuccess)
    } catch (ex) {
      this.visible = true
      if (ex.s == 901) {
        this.handleError(this.i18n.passwordHint)
      } else {
        this.handleError(ex.msg)
      }
    } finally {
      this.confirmLoading = false
    }
  }

  logout() {
    this.$store.commit('logout')
    this.$router.push({
      name: 'login'
    })
  }
}
